export default __webpack_public_path__ + "static/media/logo_total.70f872e5.png";